import { Component, OnInit } from '@angular/core';
import {DataOperationService} from "../../utils/data-services/data-operation.service";
import {ActivatedRoute, Router} from "@angular/router";
import {DataConcessionService} from "../../utils/data-services/dataConcession.service";

@Component({
  selector: 'app-modification-mass-operation',
  templateUrl: './modification-mass-operation.component.html',
  styleUrls: ['./modification-mass-operation.component.scss']
})
export class ModificationMassOperationComponent implements OnInit {

  concessionName: any;
  operationSelection = [];
  operation = {
    minimum_delay: '',
    actif: false,
    blocked: false
  };
  updateValues = {
    minimum_delay: false,
    actif: false,
    blocked: false
  };
  typeArray = [];
  constructor( private dataService: DataOperationService, private route: Router ) { }

  ngOnInit() {
    this.operationSelection = JSON.parse(localStorage.getItem('operationSelection'));
    console.log(this.operationSelection);
  }
  onClickMassUpdate() {
    for (const operation of this.operationSelection) {
      if (this.updateValues.minimum_delay) {
        operation.minimum_delay = this.operation.minimum_delay;
      }
      if (this.updateValues.actif) {
        operation.actif = this.operation.actif;
      }
      if (this.updateValues.blocked) {
        operation.blocked = this.operation.blocked;
      }
    }
    // console.log(this.operationSelection);
    this.updateOperation();
  }
  updateOperation() {
    this.dataService.updateOperation(this.operationSelection).subscribe(result => {
      this.route.navigate(['../gestion-operation/' + this.operationSelection[0].concession_id]);
    });
  }
  onCancelClik() {
    this.route.navigate(['../gestion-operation/' + this.operationSelection[0].concession_id]);
  }
  onChangeCheckbox(type) {
    this.operation[type] = !this.operation[type];
  }
  onChangeCheckboxSelection(type) {
    this.updateValues[type] = !this.updateValues[type];
  }
}
